import { render } from "./FilterSuggestionHeader.vue?vue&type=template&id=06535bde"
import script from "./FilterSuggestionHeader.vue?vue&type=script&lang=js"
export * from "./FilterSuggestionHeader.vue?vue&type=script&lang=js"
script.render = render

export default script